import { useCallback } from 'react';
import { PlayerStatuses, mediaPlaybackActions } from '../../stores/AudioPlaybackStore';
import { getValidatedEndTime, getValidatedStartTime, isEndTimeBeforeCurrentTime } from '../../../utils/recordingClipUtils';
export const useClipControls = ({
  clipEndTime,
  clipStartTime,
  handlePause,
  handleSetPlayerHeadLocation,
  mediaRef,
  mediaStateDispatch,
  preciseDuration,
  status
}) => {
  return {
    handleSetClipEndTime: useCallback((time, updateCurrentTime = true) => {
      const validatedEndTime = getValidatedEndTime(clipStartTime, time, preciseDuration);
      mediaStateDispatch(mediaPlaybackActions.setClipEndTime(validatedEndTime));

      // If end time is before current player head and player is playing, pause player
      if (mediaRef.current && mediaRef.current.currentTime >= validatedEndTime && status !== PlayerStatuses.PAUSED) {
        handlePause();
      }

      // Update current time to the end time if player is already past end time
      if (updateCurrentTime && isEndTimeBeforeCurrentTime(mediaRef, validatedEndTime)) {
        handleSetPlayerHeadLocation(validatedEndTime);
      }
    }, [mediaRef, mediaStateDispatch, clipStartTime, handlePause, handleSetPlayerHeadLocation, preciseDuration, status]),
    handleSetClipStartTime: useCallback((time, updateCurrentTime = true) => {
      const validatedStartTime = getValidatedStartTime(time, clipEndTime);
      mediaStateDispatch(mediaPlaybackActions.setClipStartTime(validatedStartTime));
      if (updateCurrentTime) {
        handleSetPlayerHeadLocation(validatedStartTime);
      }
    }, [mediaStateDispatch, clipEndTime, handleSetPlayerHeadLocation])
  };
};